import { render } from "./AlertUser.vue?vue&type=template&id=52413d07&scoped=true"
import script from "./AlertUser.vue?vue&type=script&lang=js"
export * from "./AlertUser.vue?vue&type=script&lang=js"

import "./AlertUser.vue?vue&type=style&index=0&id=52413d07&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52413d07"]])

export default __exports__